// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intake-document-upload {
  margin: 20px 0;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #fafafa;
}

.upload-header {
  margin-bottom: 16px;
}

.upload-header h4 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.required-indicator {
  color: #e74c3c;
  font-weight: bold;
}

.upload-instructions {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

/* Document Type Selection Styles */
.document-type-selection {
  margin: 16px 0;
  padding: 16px;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.document-type-label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.document-type-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.document-type-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.document-type-select:hover {
  border-color: #007bff;
}

.document-type-help {
  margin: 8px 0 0 0;
  color: #666;
  font-size: 12px;
  line-height: 1.4;
}

.upload-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  margin-bottom: 16px;
  background-color: #ffeaea;
  border: 1px solid #ffcdd2;
  border-radius: 4px;
  color: #c62828;
  font-size: 14px;
}

.error-icon {
  font-size: 16px;
}

.upload-dropzone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background-color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
}

.upload-dropzone:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
}

.upload-dropzone.drag-over {
  border-color: #007bff;
  background-color: #e3f2fd;
  transform: scale(1.02);
}

.upload-dropzone.uploading {
  border-color: #28a745;
  background-color: #f0f8f0;
  cursor: not-allowed;
}

.upload-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.upload-text {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 16px;
}

.upload-link {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.upload-link:hover {
  color: #0056b3;
}

.upload-limits {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.upload-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.uploaded-documents {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  background: transparent !important;
}

.uploaded-documents h5 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.document-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: transparent !important;
}

.document-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #ffffff !important;
  background-color: #ffffff !important;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-height: 60px;
  box-shadow: none !important;
}

.document-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
}

.document-info {
  flex: 1 1;
  min-width: 0;
  background: transparent !important;
}

.document-name {
  font-weight: 500;
  color: #333 !important;
  margin-bottom: 4px;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.4;
}

.document-meta {
  font-size: 12px;
  color: #666 !important;
  background: transparent !important;
}

.delete-document-btn {
  background: none !important;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 16px;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  box-shadow: none !important;
}

.delete-document-btn:hover {
  background-color: #ffebee;
}

.delete-document-btn:active {
  background-color: #ffcdd2;
}

.validation-message {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  color: #856404;
  font-size: 14px;
}

/* Transferred document styles */
.document-item.transferred {
  background: #f8f9fa !important;
  border-color: #28a745;
  opacity: 0.9;
}

.document-item.transferred:hover {
  border-color: #28a745;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.1);
}

.document-type-tag {
  margin-left: 8px;
  font-size: 11px;
  color: #6c757d;
  font-weight: 500;
  background: #e9ecef;
  padding: 2px 6px;
  border-radius: 12px;
  display: inline-block;
  border: 1px solid #dee2e6;
}

.transfer-status {
  margin-left: 8px;
  font-size: 12px;
  color: #28a745;
  font-weight: 500;
  background: #d4edda;
  padding: 2px 6px;
  border-radius: 12px;
  display: inline-block;
}

.transfer-date {
  color: #28a745 !important;
  font-weight: 500;
}

.transferred-indicator {
  background: none !important;
  border: none;
  font-size: 18px;
  color: #28a745;
  padding: 4px 8px;
  flex-shrink: 0;
  cursor: default;
}

/* Responsive design */
@media (max-width: 768px) {
  .intake-document-upload {
    padding: 16px;
  }
  
  .upload-dropzone {
    padding: 30px 16px;
  }
  
  .upload-icon {
    font-size: 36px;
    margin-bottom: 12px;
  }
  
  .upload-text {
    font-size: 14px;
  }
  
  .document-item {
    padding: 10px;
  }
  
  .document-name {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/IntakeFormDocumentUpload.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".intake-document-upload {\n  margin: 20px 0;\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #fafafa;\n}\n\n.upload-header {\n  margin-bottom: 16px;\n}\n\n.upload-header h4 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.required-indicator {\n  color: #e74c3c;\n  font-weight: bold;\n}\n\n.upload-instructions {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Document Type Selection Styles */\n.document-type-selection {\n  margin: 16px 0;\n  padding: 16px;\n  background-color: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.document-type-label {\n  display: block;\n  margin-bottom: 8px;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.document-type-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: #fff;\n  font-size: 14px;\n  color: #333;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.document-type-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.document-type-select:hover {\n  border-color: #007bff;\n}\n\n.document-type-help {\n  margin: 8px 0 0 0;\n  color: #666;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.upload-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  margin-bottom: 16px;\n  background-color: #ffeaea;\n  border: 1px solid #ffcdd2;\n  border-radius: 4px;\n  color: #c62828;\n  font-size: 14px;\n}\n\n.error-icon {\n  font-size: 16px;\n}\n\n.upload-dropzone {\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  padding: 40px 20px;\n  text-align: center;\n  background-color: #fff;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.upload-dropzone:hover {\n  border-color: #007bff;\n  background-color: #f8f9fa;\n}\n\n.upload-dropzone.drag-over {\n  border-color: #007bff;\n  background-color: #e3f2fd;\n  transform: scale(1.02);\n}\n\n.upload-dropzone.uploading {\n  border-color: #28a745;\n  background-color: #f0f8f0;\n  cursor: not-allowed;\n}\n\n.upload-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.6;\n}\n\n.upload-text {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.upload-link {\n  color: #007bff;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.upload-link:hover {\n  color: #0056b3;\n}\n\n.upload-limits {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.upload-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.uploaded-documents {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n  background: transparent !important;\n}\n\n.uploaded-documents h5 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.document-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: transparent !important;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: #ffffff !important;\n  background-color: #ffffff !important;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  min-height: 60px;\n  box-shadow: none !important;\n}\n\n.document-item:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);\n}\n\n.document-info {\n  flex: 1;\n  min-width: 0;\n  background: transparent !important;\n}\n\n.document-name {\n  font-weight: 500;\n  color: #333 !important;\n  margin-bottom: 4px;\n  word-break: break-word;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.document-meta {\n  font-size: 12px;\n  color: #666 !important;\n  background: transparent !important;\n}\n\n.delete-document-btn {\n  background: none !important;\n  border: none;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 16px;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n  box-shadow: none !important;\n}\n\n.delete-document-btn:hover {\n  background-color: #ffebee;\n}\n\n.delete-document-btn:active {\n  background-color: #ffcdd2;\n}\n\n.validation-message {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  color: #856404;\n  font-size: 14px;\n}\n\n/* Transferred document styles */\n.document-item.transferred {\n  background: #f8f9fa !important;\n  border-color: #28a745;\n  opacity: 0.9;\n}\n\n.document-item.transferred:hover {\n  border-color: #28a745;\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.1);\n}\n\n.document-type-tag {\n  margin-left: 8px;\n  font-size: 11px;\n  color: #6c757d;\n  font-weight: 500;\n  background: #e9ecef;\n  padding: 2px 6px;\n  border-radius: 12px;\n  display: inline-block;\n  border: 1px solid #dee2e6;\n}\n\n.transfer-status {\n  margin-left: 8px;\n  font-size: 12px;\n  color: #28a745;\n  font-weight: 500;\n  background: #d4edda;\n  padding: 2px 6px;\n  border-radius: 12px;\n  display: inline-block;\n}\n\n.transfer-date {\n  color: #28a745 !important;\n  font-weight: 500;\n}\n\n.transferred-indicator {\n  background: none !important;\n  border: none;\n  font-size: 18px;\n  color: #28a745;\n  padding: 4px 8px;\n  flex-shrink: 0;\n  cursor: default;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .intake-document-upload {\n    padding: 16px;\n  }\n  \n  .upload-dropzone {\n    padding: 30px 16px;\n  }\n  \n  .upload-icon {\n    font-size: 36px;\n    margin-bottom: 12px;\n  }\n  \n  .upload-text {\n    font-size: 14px;\n  }\n  \n  .document-item {\n    padding: 10px;\n  }\n  \n  .document-name {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
